module.exports = __webpack_public_path__ + "media/images/v2/illustration_3-e66d1d4ff0dbd9efeba999f30cd42746.svg";